import { YMInitializer } from "react-yandex-metrika";
import { env } from "~/env";

export const YandexMetrika = () => (
  <YMInitializer
    accounts={[env.VITE_YM_ID]}
    options={{
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      ecommerce: "dataLayer",
    }}
    version="2"
  />
);
